"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _MergeOutlined = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/MergeOutlined"));
var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

var MergeOutlined = function MergeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, (0, _extends2.default)({}, props, {
    ref: ref,
    icon: _MergeOutlined.default
  }));
};

/**![merge](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjQ4IDc1Mmg3MlYyNjRoLTcyeiIgLz48cGF0aCBkPSJNNzQwIDg2M2M2MS44NiAwIDExMi01MC4xNCAxMTItMTEyIDAtNDguMzMtMzAuNi04OS41LTczLjUtMTA1LjJsLS4wMS0xMTMuMDRhNTAuNzMgNTAuNzMgMCAwMC0zNC45NS00OC4ybC00MzQuOS0xNDIuNDEtMjIuNCA2OC40MiA0MjAuMjUgMTM3LjYxLjAxIDk1LjkyQzY2MSA2NTguMzQgNjI4IDcwMC44IDYyOCA3NTFjMCA2MS44NiA1MC4xNCAxMTIgMTEyIDExMm0tNDU2IDYxYzYxLjg2IDAgMTEyLTUwLjE0IDExMi0xMTJzLTUwLjE0LTExMi0xMTItMTEyLTExMiA1MC4xNC0xMTIgMTEyIDUwLjE0IDExMiAxMTIgMTEybTQ1Ni0xMjVhNDggNDggMCAxMTAtOTYgNDggNDggMCAwMTAgOTZtLTQ1NiA2MWE0OCA0OCAwIDExMC05NiA0OCA0OCAwIDAxMCA5Nm0wLTUzNmM2MS44NiAwIDExMi01MC4xNCAxMTItMTEycy01MC4xNC0xMTItMTEyLTExMi0xMTIgNTAuMTQtMTEyIDExMiA1MC4xNCAxMTIgMTEyIDExMm0wLTY0YTQ4IDQ4IDAgMTEwLTk2IDQ4IDQ4IDAgMDEwIDk2IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(MergeOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'MergeOutlined';
}
var _default = exports.default = RefIcon;